import type { SxProps, Theme } from '@mui/material/styles'
import { MetricState } from './index'
import MetricStateIndicator from './MetricStateIndicator'

type ClimateComputationIndicatorProps = {
  /** `inline` sits next to text/values; `block` fills a card body region. */
  variant?: 'inline' | 'block'
  label?: string
  /** Minimum height for the `block` variant so cards don't collapse. */
  minHeight?: number
  sx?: SxProps<Theme>
}

const ClimateComputationIndicator = ({
  variant = 'inline',
  label = 'Calculating…',
  minHeight = 80,
  sx,
}: ClimateComputationIndicatorProps) => {
  return (
    <MetricStateIndicator
      state={MetricState.RUNNING}
      variant={variant}
      label={label}
      message={null}
      minHeight={minHeight}
      showLabel={Boolean(label)}
      sx={sx}
    />
  )
}

export default ClimateComputationIndicator
